// extracted by mini-css-extract-plugin
module.exports = {"stepText":"StepLabel_stepText__2L26N"};